import { useContext, useEffect, useMemo, useState } from 'react';
import {
  CardHeader,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button,
  Input,
  Badge,
} from 'reactstrap';

import api from 'services/api';
import { PropostaMaterialAvulso as IPropostaMaterialAvulso } from 'models/PropostaMaterialAvulso';
import { PropostaVersao } from 'models/PropostaVersao';
import Produto from 'models/Produto';
import AtividadeModel from 'models/ConfiguradorAtividade';
import PropostaVersaoProduto from 'models/PropostaVersaoProduto';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import AutocompleteItemDomsge from 'components/AutocompleteItemDomsge';
import { FaPlusCircle } from 'react-icons/fa';
import ItemDomsge from 'models/ItemDomsge';
import { Checkbox, CircularProgress } from '@material-ui/core';
import toast from 'react-hot-toast';
import { PropostaContext } from 'views/pages/Proposta';
import { useQuery } from 'react-query';
import ValidarAcessoPrograma from 'models/ValidarAcessoPrograma';
import { useHistory } from 'react-router-dom';
import mensagemAtingirMeta from 'utils/mensagemAtingirMeta';
import AutocompleteItem, {
  iAutoCompleteItem,
} from 'components/AutocompleteItem';
import traduzirProdutoAtividade from 'utils/traduzirProdutoAtividade';
import ProdutoAtividade from 'models/ProdutoAtividade';
import { Th, Td } from './styles';
import MaterialItem from '../MaterialItem';
import MaterialTotalItem from '../MaterialTotalItem';
import { MateriaisContext } from '../..';

// Para desabilitar temporariamente as ações
const OCULTAR_ACOES = true;

const MySwal = withReactContent(Swal);
export default function PropostaMaterialAvulso({
  isFaturamentoDireto,
  checkedIdsAvulsos,
  campoBusca,
  setCheckedIdsAvulsos,
  marcarTodosComoFatDir,
  setMarcarTodosComoFatDir,
}: {
  isFaturamentoDireto: boolean;
  campoBusca: string;
  checkedIdsAvulsos: Set<number>;
  setCheckedIdsAvulsos: React.Dispatch<React.SetStateAction<Set<number>>>;
  marcarTodosComoFatDir: boolean;
  setMarcarTodosComoFatDir: React.Dispatch<React.SetStateAction<boolean>>;
}): JSX.Element {
  const { propostaVersao, permiteModificacao, carregaPropostaVersao } =
    useContext(PropostaContext);
  const {
    setValorItens,
    setValorFrete,
    setValorFinal,
    setValorFinalDolar,
    setValorPercentualFrete,
    setValorDesconto,
    setValorServico,
  } = useContext(MateriaisContext);
  const [materiaisAvulsos, setMateriaisAvulsos] = useState<
    IPropostaMaterialAvulso[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [itemDomsgeSelecionado, setItemDomsgeSelecionado] =
    useState<iAutoCompleteItem | null>(null);
  const [quantidadeNovoItem, setQuantidadeNovoItem] = useState(1);
  const [atividadeNovoItem, setAtividadeNovoItem] = useState<number>();
  const [atividades, setAtividades] = useState<ProdutoAtividade[]>([]);
  const [codEmpresa, setCodEmpresa] = useState('');
  const [produtoProposta, setProdutoProposta] = useState(0);
  const [acessoLimitadoListaMateriais, setAcessoLimitadoListaMateriais] =
    useState(true);
  const [acessoIncluiMaterialAvulso, setacessoIncluiMaterialAvulso] =
    useState(false);
  const [idsFiltrados, setIdsFiltrados] = useState<number[]>([]);
  const history = useHistory();

  async function getAcessoLimitadoPrograma() {
    const response = await api.get('/acesso-programa/acesso-limitado', {
      params: {
        programaId: 60,
      },
    });
    setAcessoLimitadoListaMateriais(response.data);
  }

  async function getAcesssoIncluiMaterialAvulso() {
    const response = await api.get('/acesso-programa/acesso-programa', {
      params: {
        programaId: 118,
      },
    });
    setacessoIncluiMaterialAvulso(response.data.temAcesso);
  }

  async function returnMateriaisMarcadosPropVerAnterior() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/material`,
    );

    const registrosResp = response.data;

    const fatDiretoVersaoOriginal: number[] = registrosResp.filter(
      (item: any) => item.selecionadoFatDireto === true,
    );

    const fatDiretoVersaoOriginalIds = fatDiretoVersaoOriginal.map(
      (item: any) => item.id,
    );

    setCheckedIdsAvulsos(
      prev => new Set([...prev, ...fatDiretoVersaoOriginalIds]),
    );
  }

  useEffect(() => {
    getAcessoLimitadoPrograma();
    getAcesssoIncluiMaterialAvulso();
    returnMateriaisMarcadosPropVerAnterior();
  }, []);

  const valorTotalAvulsos = materiaisAvulsos.reduce(
    (total, item) => total + Number(item.valorTotal || 0),
    0,
  );

  async function returnMateriais(): Promise<IPropostaMaterialAvulso[]> {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/material`,
    );

    return response.data;
  }

  const { data: dataMateriaisAvulsos, isLoading } = useQuery(
    ['proposta-configuracao-materiais-avulsos', propostaVersao.id],
    async () => {
      const data = await returnMateriais();
      return data;
    },
  );

  useEffect(() => {
    if (dataMateriaisAvulsos) {
      setMateriaisAvulsos(dataMateriaisAvulsos);
    }
  }, [dataMateriaisAvulsos]);

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  async function carregaMateriaisAvulsos(): Promise<void> {
    try {
      setLoading(true);
      const data = await returnMateriais();
      setMateriaisAvulsos(data);
    } finally {
      setLoading(false);
    }
  }

  async function carregaPropostaV() {
    const response = await api.get(`/proposta/versao/${propostaVersao.id}`);
    const propostaVersaoData = response.data as PropostaVersao;
    // cabeçalho
    setValorItens(propostaVersaoData.valorItens);
    setValorFrete(Number(propostaVersaoData.percentualFrete));
    setValorFinal(propostaVersaoData.valorFinal);
    setValorFinalDolar(propostaVersaoData.valorFinalDolar);
    // rodapé
    setValorPercentualFrete(propostaVersaoData.percentualFrete);
    setValorDesconto(propostaVersaoData.valorDesconto);
    setValorServico(propostaVersaoData.valorServico);
  }

  function handleOnAddFinanciamentoDiretoAvulsos(
    materialAvulso: IPropostaMaterialAvulso,
  ) {
    setCheckedIdsAvulsos(prev => {
      const newSet = new Set(prev);
      if (newSet.has(materialAvulso.id)) {
        newSet.delete(materialAvulso.id);
      } else {
        newSet.add(materialAvulso.id);
      }
      return newSet;
    });
  }

  async function addMaterialAvulso() {
    if (!itemDomsgeSelecionado) {
      return;
    }
    try {
      setUpdating(true);
      await mensagemAtingirMeta(
        `Foi adicionado um material avulso na proposta`,
        Number(propostaVersao.id),
      );

      await api.post(`/proposta/versao/${propostaVersao.id}/material`, {
        materialId: itemDomsgeSelecionado.id,
        quantidade: quantidadeNovoItem,
        atividade: atividadeNovoItem,
      });
      setItemDomsgeSelecionado(null);
      setAtividadeNovoItem(0);
      setQuantidadeNovoItem(1);

      carregaMateriaisAvulsos();
      carregaPropostaV();
      carregaPropostaVersao();
    } finally {
      setUpdating(false);
    }
  }

  async function updateMaterialAvulso(materialAvulso: IPropostaMaterialAvulso) {
    try {
      setUpdating(true);
      const { id, quantidade, atividade } = materialAvulso;
      await api.put(`/proposta/versao/${propostaVersao.id}/material/${id}`, {
        quantidade: Number(quantidade),
        atividade: atividade || '',
      });
      carregaMateriaisAvulsos();
      carregaPropostaV();
      carregaPropostaVersao();
    } finally {
      setUpdating(false);
    }
  }

  async function deleteMaterialAvulso(materialAvulsoId: number) {
    let motivo = '';

    async function deletePropostaConfiguracaoMaterial() {
      try {
        await mensagemAtingirMeta(
          `Foi removido um material avulso na proposta`,
          Number(propostaVersao.id),
        );
        setUpdating(true);
        await api.delete(
          `/proposta/versao/${propostaVersao.id}/material/${materialAvulsoId}?motivo=${motivo}`,
        );
        const novoMateriaisAvulsos = materiaisAvulsos.filter(
          materialAvulso => materialAvulso.id !== materialAvulsoId,
        );
        setMateriaisAvulsos(novoMateriaisAvulsos);
      } finally {
        setUpdating(false);
      }
    }

    async function openModal() {
      MySwal.fire({
        title: `Deseja excluir o material avulso?`,
        html: `<br />
        <strong>Informe um motivo da exclusão do material:</strong>
        <input id="swal-input1" value='${motivo}' class="swal2-input">`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, excluir`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      }).then(result => {
        const input = Swal?.getHtmlContainer()?.querySelector(
          '#swal-input1',
        ) as any;

        motivo = input.value;
        if (result.isConfirmed) {
          if (motivo.length < 5) openModal();
          else deletePropostaConfiguracaoMaterial();
        }
      });
    }

    openModal();
  }

  async function listaAtividades() {
    const response = await api.get('/produto-atividade');
    setAtividades(response.data);
  }

  async function buscarCodigoEmpresaProposta() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/empresa-proposta`,
    );
    setCodEmpresa(response.data);
  }

  async function buscarProdutoProposta() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/produto-proposta`,
    );
    setProdutoProposta(Number(response.data));
  }

  useEffect(() => {
    if (propostaVersao.id) {
      listaAtividades();
      buscarProdutoProposta();
      buscarCodigoEmpresaProposta();
    }
  }, [propostaVersao]);

  useEffect(() => {
    if (updating) {
      toast.loading('Aguarde...', { position: 'top-right' });
      return;
    }

    toast.dismiss();
  }, [updating]);

  function handleChangeValue(id: number, name: string, value: number | string) {
    const novoMateriaisAvulsos = materiaisAvulsos.map(materialAvulso =>
      materialAvulso.id === id
        ? {
            ...materialAvulso,
            [name]: value,
          }
        : materialAvulso,
    );
    setMateriaisAvulsos(novoMateriaisAvulsos);
  }

  function handleSelecionarItem(itemDomsge: iAutoCompleteItem | null) {
    setItemDomsgeSelecionado(itemDomsge);
  }

  const materiaisFiltrados = useMemo(() => {
    if (!materiaisAvulsos?.length) return [];

    if (campoBusca) {
      return materiaisAvulsos.filter(
        item => item.material.descricaoFabrSge === campoBusca.toUpperCase(),
      );
    }
    return materiaisAvulsos;
  }, [materiaisAvulsos, campoBusca]);

  useEffect(() => {
    if (materiaisFiltrados.length > 0 && campoBusca !== '') {
      const ids = materiaisFiltrados.map(item => item.id);
      setIdsFiltrados([...ids]);

      if (marcarTodosComoFatDir) {
        const idsUsar = new Set([...ids, ...idsFiltrados]);
        Array.from(idsUsar).map(item => {
          setCheckedIdsAvulsos(prev => {
            const newSet = new Set(prev);
            if (newSet.has(item)) {
              newSet.delete(item);
            } else {
              newSet.add(item);
            }
            return newSet;
          });
          return null;
        });
        setMarcarTodosComoFatDir(false);
      }
    }
    // else if (campoBusca === '') {
    // setIdsFiltrados([]);
    // }
  }, [materiaisFiltrados, marcarTodosComoFatDir]);

  function Materiais(): JSX.Element {
    if (!materiaisAvulsos.length) {
      return (
        <tr>
          <Td className="text-center" colSpan={5}>
            Nenhum registro encontrado
          </Td>
        </tr>
      );
    }

    console.log({ materiaisAvulsos });
    /**
     *
    let materiaisAvulsosFiltrado = materiaisAvulsos;

    if (campoBusca) {
      materiaisAvulsosFiltrado = materiaisAvulsos.filter(
        item => item.material.descricaoFabrSge === campoBusca.toUpperCase(),
      );
    }
    */

    return (
      <>
        {materiaisFiltrados.map(materialAvulso => {
          const { id } = materialAvulso;
          return (
            <MaterialItem
              key={id}
              propostaMaterial={materialAvulso}
              canEdit={acessoIncluiMaterialAvulso && permiteModificacao}
              canDelete={acessoIncluiMaterialAvulso && permiteModificacao}
              handleChangeValue={handleChangeValue}
              disabled={updating}
              onClickUpdate={() => updateMaterialAvulso(materialAvulso)}
              onClickDelete={() => deleteMaterialAvulso(id)}
              acessoLimitadoListaMateriais={acessoLimitadoListaMateriais}
              isAvulso
              isChecked={checkedIdsAvulsos.has(id)}
              onAddFinanciamentoDireto={() =>
                handleOnAddFinanciamentoDiretoAvulsos(materialAvulso)
              }
              isFaturamentoDireto={isFaturamentoDireto}
            />
          );
        })}
      </>
    );
  }

  return (
    <>
      <CardHeader>
        <Row>
          <Col sm="10">
            <h4 className="mb--1">Materiais avulsos da proposta</h4>
            <small className="text-muted"> </small>
          </Col>
          {acessoIncluiMaterialAvulso && (
            <Col className="align-items-right" sm="2">
              <Button
                size="sm"
                disabled={updating}
                className="btn-icon btn-2"
                style={{ backgroundColor: '#1a8c5b' }}
                color="success"
                type="button"
                onClick={() => {
                  // eslint-disable-next-line no-restricted-globals
                  history.push({
                    pathname: `/admin/configurador-itens-lote`,
                    state: {
                      propostaId: propostaVersao.id,
                      emprCodigo: codEmpresa,
                    },
                  });
                }}
              >
                <span className="btn-inner--text">Cadastro em lote</span>
              </Button>
            </Col>
          )}
        </Row>
      </CardHeader>

      {permiteModificacao && acessoIncluiMaterialAvulso && (
        <Card>
          <AutocompleteItem
            hideTitle
            handleSelecionarItem={handleSelecionarItem}
            maxWidth="60vw"
            noAutoFocus
            emprCodigo={codEmpresa}
          >
            <Input
              type="number"
              min={1}
              className="ml-2"
              value={quantidadeNovoItem}
              onChange={event =>
                setQuantidadeNovoItem(parseInt(event.target.value, 10))
              }
            />

            <Input
              className="ml-2"
              type="select"
              value={atividadeNovoItem !== 0 ? atividadeNovoItem : ''}
              onChange={text => setAtividadeNovoItem(Number(text.target.value))}
            >
              <option value="">Atividade</option>
              {atividades
                .filter(item => item.produtoId === produtoProposta)
                ?.map(ativ => (
                  <option
                    key={ativ.id}
                    value={ativ.id}
                    title={ativ.codSGE ? `Ref. DomSGE: ${ativ.codSGE}` : ''}
                  >
                    {traduzirProdutoAtividade(ativ)}
                  </option>
                ))}
            </Input>
            <Button
              disabled={updating}
              className="btn-icon btn-2"
              color="primary"
              type="button"
              onClick={addMaterialAvulso}
            >
              <FaPlusCircle />
            </Button>
          </AutocompleteItem>
        </Card>
      )}

      <Card>
        <CardBody className="p-1">
          {loading ? (
            <Row>
              <Col className="text-center mb-4 mt-4">
                <CircularProgress />
              </Col>
            </Row>
          ) : (
            <Table bordered responsive>
              <thead>
                <tr>
                  <Th>&nbsp;</Th>
                  <Th>Ativ</Th>
                  <Th>Item</Th>
                  <Th className="text-center">Quantidade</Th>
                  {!acessoLimitadoListaMateriais && (
                    <>
                      <Th className="text-right">Valor unitário</Th>
                      <Th className="text-right">Valor total</Th>
                    </>
                  )}{' '}
                  {isFaturamentoDireto && <Th>Fat. Direto</Th>}
                  {materiaisAvulsos.length > 0 &&
                    permiteModificacao &&
                    !isFaturamentoDireto && <Th />}
                </tr>
              </thead>
              <tbody>{Materiais()}</tbody>
              <tfoot hidden={campoBusca !== ''}>
                <MaterialTotalItem
                  texto="Total materiais avulsos"
                  valor={valorTotalAvulsos}
                  elementType="h2"
                  acessoLimitadoListaMateriais={acessoLimitadoListaMateriais}
                  isAvulso
                />
              </tfoot>
            </Table>
          )}
        </CardBody>
      </Card>
    </>
  );
}
